import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44f8bdea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row items-start justify-start q-ml-md" }
const _hoisted_2 = { class: "col-xs-10 col-md-4 column justify-start q-ma-md" }
const _hoisted_3 = { class: "text-h6" }
const _hoisted_4 = { class: "text-h6" }
const _hoisted_5 = { class: "text-h6" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 0,
  class: "col-xs-10 col-md-4 column justify-start q-ma-md"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentUser)
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 0,
            class: "my-card bg-grey-2",
            flat: "",
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('profile.profile')) + ": " + _toDisplayString(_ctx.currentUser.username), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('profile.email')) + ": " + _toDisplayString(_ctx.currentUser.email), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('profile.token')) + ": " + _toDisplayString(_ctx.currentUser.token), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_q_btn, {
                  label: _ctx.t('dialog.change'),
                  class: "full-width",
                  size: "lg",
                  color: "primary",
                  onClick: _ctx.toggleView
                }, null, 8, ["label", "onClick"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.formshow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_q_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_form, {
                onSubmit: _ctx.handleUpdate,
                class: "q-gutter-md"
              }, {
                default: _withCtx(() => [
                  (!_ctx.successful)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_q_input, {
                          filled: "",
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                          label: _ctx.t('profile.email'),
                          class: "q-mb-md",
                          hint: _ctx.t('profile.enteremail'),
                          "lazy-rules": "",
                          rules: [ val => val && val.length > 0 || _ctx.t('profile.emailisrequired'),
                        val => val.length <50 || _ctx.t('profile.mustbemaximum50ch'),
                        _ctx.isValidEmail]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "email" })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "hint", "rules"]),
                        _createVNode(_component_q_input, {
                          class: "q-mb-md",
                          filled: "",
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                          label: _ctx.t('login.password'),
                          hint: _ctx.t('login.enterpassword'),
                          type: _ctx.passwordFieldType,
                          "lazy-rules": "",
                          rules: [ val => val && val.length > 0 || _ctx.t('profile.passwordrequired'),
                        val => val.length >=6 || _ctx.t('profile.mustbeatleast6ch'),
                        val => val.length < 40 || _ctx.t('profile.mustbemaximum40'),]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "lock" })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: _ctx.visibilityIcon,
                              onClick: _ctx.switchVisibility,
                              class: "cursor-pointer"
                            }, null, 8, ["name", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "hint", "type", "rules"]),
                        _createVNode(_component_q_input, {
                          class: "q-mb-md",
                          filled: "",
                          modelValue: _ctx.confpassword,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confpassword) = $event)),
                          label: _ctx.t('profile.confirmationpassword'),
                          hint: _ctx.t('profile.enterconfirmationpassword'),
                          type: _ctx.passwordFieldType,
                          "lazy-rules": "",
                          rules: [ val => val && val.length > 0 || _ctx.t('login.passwordrequired'),
                          val => val.length >=6 || _ctx.t('profile.mustbeatleast6ch'),
                          val => val.length < 40 || _ctx.t('profile.mustbemaximum40'),
                          _ctx.diffPassword]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "lock" })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: _ctx.visibilityIcon,
                              onClick: _ctx.switchVisibility,
                              class: "cursor-pointer"
                            }, null, 8, ["name", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "hint", "type", "rules"]),
                        _createVNode(_component_q_input, {
                          class: "q-mb-md",
                          filled: "",
                          modelValue: _ctx.userpassword,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userpassword) = $event)),
                          label: _ctx.t('profile.userpassword'),
                          hint: _ctx.t('profile.enteruserpassword'),
                          type: _ctx.passwordFieldType,
                          "lazy-rules": "",
                          rules: [ val => val && val.length > 0 || _ctx.t('login.passwordrequired'),
                          val => val.length >=6 || _ctx.t('profile.mustbeatleast6ch'),
                          val => val.length < 40 || _ctx.t('profile.mustbemaximum40'),]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "lock" })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: _ctx.visibilityIcon,
                              onClick: _ctx.switchVisibility,
                              class: "cursor-pointer"
                            }, null, 8, ["name", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "hint", "type", "rules"]),
                        _createVNode(_component_q_input, {
                          class: "q-mb-md",
                          filled: "",
                          modelValue: _ctx.confuserpassword,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confuserpassword) = $event)),
                          label: _ctx.t('profile.confirmationuserpassword'),
                          hint: _ctx.t('profile.enterconfirmationuserpassword'),
                          type: _ctx.passwordFieldType,
                          "lazy-rules": "",
                          rules: [ val => val && val.length > 0 || _ctx.t('login.passwordrequired'),
                          val => val.length >=6 || _ctx.t('profile.mustbeatleast6ch'),
                          val => val.length < 40 || _ctx.t('profile.mustbemaximum40'),
                          _ctx.diffUserPassword]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "lock" })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: _ctx.visibilityIcon,
                              onClick: _ctx.switchVisibility,
                              class: "cursor-pointer"
                            }, null, 8, ["name", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "hint", "type", "rules"]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_q_btn, {
                            label: _ctx.t('profile.save'),
                            class: "full-width",
                            size: "lg",
                            type: "submit",
                            color: "primary",
                            loading: _ctx.loading,
                            disable: _ctx.loading
                          }, null, 8, ["label", "loading", "disable"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]),
            _: 1
          }),
          (_ctx.message)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["alert", _ctx.successful ? 'alert-success' : 'alert-danger'])
              }, _toDisplayString(_ctx.message), 3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}